var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var QuantileColumn_1;
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import './quantile'; // force import for JsonSchemaV2
import { quantileColumnSchemaValidation } from '../validations.generated';
// when calling quantile([q1, q2, etc]) in pandas, the quantiles must be unique, so the schema
// is done this way so that it can check uniqueness.  Alias uniqueness must be done by the config
// since it will be across all quantilecolumns
export const quantileColumnSchema = {
    $id: 'urn:wisepipe-common-pipe:QuantileColumn',
    type: 'object',
    properties: {
        column: { type: 'string' },
        quantiles: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:Quantile' },
            uniqueItemProperties: ['quantile'],
            minItems: 1
        }
    },
    required: ['column', 'quantiles']
};
let QuantileColumn = QuantileColumn_1 = class QuantileColumn {
    constructor(column, quantiles) {
        this.quantiles = quantiles;
        this.column = column;
        JSON.validate(this, QuantileColumn_1);
    }
};
QuantileColumn = QuantileColumn_1 = __decorate([
    JsonSchemaV2(quantileColumnSchema, quantileColumnSchemaValidation)
], QuantileColumn);
export { QuantileColumn };
//# sourceMappingURL=quantileColumn.js.map